export default __webpack_public_path__ + "static/media/Group 1399.ef155f94.png";